import { useField } from 'formik';
import { styled } from '@mui/material/styles';
import React from 'react';
import Typography from '@mui/material/Typography';
import Slider from '@mui/material/Slider';
import FormHelperText from '@mui/material/FormHelperText';
import propTypes from 'prop-types';

const PREFIX = 'Slider';

const classes = {
  root: `${PREFIX}-root`,
  margin: `${PREFIX}-margin`
};

const Root = styled('div')((
  {
    theme
  }
) => ({
  [`&.${classes.root}`]: {
    width: '100%',
    padding: theme.spacing(0, 5)
  },

  [`& .${classes.margin}`]: {
    height: theme.spacing(3),
  }
}));

export default function MaterialSlider(props) {

  const [field, meta, helpers] = useField(props.name);

  return (
    <Root className={classes.root}>
      <Typography
        color={meta.touched && meta.error ? 'error' : 'textPrimary'}
        id='input-slider'
        gutterBottom
        style={{ display: 'flex', alignItems: 'center' }}
        component='span'
      >
        {props.label}: {meta.value ? meta.value : ''}
      </Typography>
      <Slider
        {...field}
        aria-labelledby={field.id}
        value={typeof meta.value === 'number' ? meta.value : 1}
        onBlur={(e) => helpers.setTouched(e)}
        onChange={(e, v) => helpers.setValue(v)}
        min={props.min}
        max={props.max}
        marks={props.marks}
        step={props.step}
      />
      {
        meta.touched && meta.error ? (
          <FormHelperText error >{meta.error}</FormHelperText>
        ) : null
      }
    </Root>
  );
}

MaterialSlider.propTypes = {
  name: propTypes.string,
  label: propTypes.oneOfType([propTypes.string, propTypes.element]),
  min: propTypes.number,
  max: propTypes.number,
  step: propTypes.number,
  marks: propTypes.array,
};
